import React from 'react';

import { useColourPickerContext } from '../ColourPickerContext';
import ColourSwatchCard from './ColourSwatchCard';
import ColourSwatchPdp from './ColourSwatchPdp';

export { default as ColourSwatchCard } from './ColourSwatchCard';
export { default as ColourSwatchPdp } from './ColourSwatchPdp';

interface ColourSwatchProps {
  colourId: number;
}

/**
 * Dispatches to explicit variant components. Prefer composing
 * `ColourSwatchCard` / `ColourSwatchPdp` at the callsite (e.g. Grid) when
 * variant is already known; use this when the consumer only has context.
 */
const ColourSwatch: React.FC<ColourSwatchProps> = ({ colourId }) => {
  const { variant } = useColourPickerContext();
  if (variant === 'card') {
    return <ColourSwatchCard colourId={colourId} />;
  }
  return <ColourSwatchPdp colourId={colourId} />;
};

export default ColourSwatch;
